<template>
  <nav class="normal footer-sitemap">
    <div class="common-section">
      <el-collapse>
        <h3><router-link to="/">TOP</router-link></h3>
        <el-collapse-item title="会社概要" name="1">
          <ul class="list list-vertical">
            <li><router-link to="/company#history">沿革</router-link></li>
          </ul>
        </el-collapse-item>
        <h3><router-link to="/news">企業情報</router-link></h3>
        <el-collapse-item title="製品カテゴリー" name="2">
          <ul class="list list-vertical">
            <li v-for="(item,index) in catalog" :key="item.id"><router-link :to="{path: `/product/${item.id}`}">{{item.name}}</router-link></li>
          </ul>
        </el-collapse-item>
        <h3><router-link to="/agency">販売代理店</router-link></h3>
        <el-collapse-item title="お問い合わせ" name="3">
          <ul class="list list-vertical">
            <li><a href="javascript:;">電話:03-300-2043</a></li>
            <li><a href="javascript:;">FAX:03-300-2043</a></li>
          </ul>
        </el-collapse-item>
      </el-collapse>
    </div>
  </nav>
</template>
<script>
  import { mapState } from 'vuex'
  export default {
    computed: {
      ...mapState(['catalog'])
    },
    methods: {
    }
  }
</script>
<style type="text/scss" lang="scss" rel="stylesheet/scss" scoped>
  @import "../../styles/declaration";
  @media screen and (max-width: 767px) {
    .normal{
      text-align: left;
      border-bottom: none;
    }
    .footer-sitemap {
      margin-top: 0;
      background-color: #1b1b1b;
      .common-section{
        padding-bottom: 0;
      }
      h3 a{
        border-bottom: none;
        color: #ffffff;
        position: relative;
        display: block;
        line-height: 36px;
      }
      .box-element h3 a:after{
        content: "";
        position: absolute;
        left: auto;
        right: 25px;
        width: 12px;
        height: 12px;
        /*background: url('../assets/icons/arrow_white.png') no-repeat center;*/
        background-size: cover;
      }
      .list.list-vertical li:first-child{
        margin-top: 0;
      }
      .list a {
        text-align: left;
        color: #a3a3a3;
        font-size: 14px;
        line-height: 1.3;
      }
    }
  }
</style>
<style>
  .el-collapse-item__header{
    border: none;
    color: #ffffff;
    background-color: #1b1b1b;
    font-size: 16px;
  }
  .el-collapse,.el-collapse-item__wrap{
    border: none;
  }
  .el-collapse-item__wrap{
    background-color: #1b1b1b;
  }
  .el-collapse-item__arrow.el-icon-arrow-right{
    line-height: inherit;
  }
  .el-collapse-item__content{
    padding-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/MSitemap.vue